import * as Yup from 'yup';

export const signInConfirmSchema = Yup.object().shape({
    mfaType: Yup.string().oneOf(['SMS', 'TOTP', 'EMAIL']).required(),
    code: Yup.string().min(6).max(6).required(),
});
